import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Play, CheckCircle2 } from "lucide-react";
import { HERO } from "../../mock/mock";

export default function Hero() {
  const title = HERO.title.replace(HERO.highlight, "|||").split("|||");
  return (
    <section className="relative overflow-hidden bg-homi-cream">
      <div className="absolute top-0 right-0 w-1/2 h-full bg-gradient-to-br from-homi-gold/5 to-transparent pointer-events-none" />
      <div className="absolute -top-24 -right-24 w-96 h-96 rounded-full bg-homi-gold/10 blur-3xl pointer-events-none" />
      <div className="max-w-7xl mx-auto px-6 py-16 lg:py-24 grid lg:grid-cols-2 gap-12 items-center relative">
        <div className="animate-fade-up">
          <span className="homi-section-tag inline-flex items-center gap-2 text-homi-goldDark text-sm mb-5">
            <span className="w-8 h-0.5 bg-homi-gold inline-block" /> {HERO.tag}
          </span>
          <h1 className="font-heading font-extrabold text-4xl md:text-5xl lg:text-6xl leading-[1.1] text-homi-black mb-6">
            {title[0]}<span className="text-homi-gold">{HERO.highlight}</span>{title[1]}
          </h1>
          <p className="text-lg text-homi-body max-w-xl mb-8 leading-relaxed">{HERO.subtitle}</p>
          <div className="flex flex-wrap items-center gap-4 mb-10">
            <Link to={HERO.primaryCta.path} className="homi-btn-shine inline-flex items-center gap-2 bg-homi-gold hover:bg-homi-goldDark text-homi-black font-heading font-bold px-7 py-4 rounded-lg transition-colors">
              {HERO.primaryCta.label} <ArrowRight className="w-5 h-5" />
            </Link>
            <Link to={HERO.secondaryCta.path} className="inline-flex items-center gap-3 text-homi-black font-heading font-bold group">
              <span className="w-12 h-12 rounded-full border-2 border-homi-gold flex items-center justify-center group-hover:bg-homi-gold transition-colors">
                <Play className="w-4 h-4 text-homi-gold group-hover:text-homi-black fill-current" />
              </span>
              {HERO.secondaryCta.label}
            </Link>
          </div>
          <div className="flex flex-wrap gap-x-8 gap-y-3">
            {["Licensed & Insured", "24/7 Support", "Free Estimates"].map((t) => (
              <span key={t} className="flex items-center gap-2 text-homi-black font-medium">
                <CheckCircle2 className="w-5 h-5 text-homi-gold" /> {t}
              </span>
            ))}
          </div>
        </div>

        <div className="relative animate-fade-up" style={{ animationDelay: "0.15s" }}>
          <div className="relative rounded-3xl overflow-hidden shadow-2xl">
            <img src={HERO.image} alt="Home renovation" className="w-full h-[440px] object-cover" />
          </div>
          <div className="absolute -bottom-6 -left-6 w-40 h-40 rounded-2xl overflow-hidden shadow-xl border-4 border-white hidden md:block animate-float">
            <img src={HERO.secondaryImage} alt="Worker" className="w-full h-full object-cover" />
          </div>
        </div>
      </div>
    </section>
  );
}
